/* angular stuff */
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuard,PermissionsGuard } from '../../services/shared/auth.guard';
//import { CommonEndpoint } from '../../services/shared/common.service';
/* our own custom */
/* Third party */

@NgModule({
    imports: [
        /* angular stuff */
        CommonModule,
        HttpClientModule,

        /* our own custom  */

        /* Third party */
    ],
    exports: [
        /* angular stuff */
        /* our own custom  */
        /* Third party */

    ],
    declarations: [
        /* angular stuff */
        /* our own custom  */
        /* Third party */
    ],
    providers: [
        /* angular stuff */
        /* our own custom  */
        AuthGuard,
        PermissionsGuard,
        //CommonEndpoint
        /* Third party */
    ]
})

export class CoreModule {
    /* make sure CoreModule is imported only by one NgModule the AppModule */
    constructor(
        @Optional() @SkipSelf() parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import only in AppModule');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/core/core.module.ts